import { ListingType } from 'algolia-api/types/ListingType';
import { StaffTypeFilter } from 'algolia-api/types/StaffTypeFilter';
import { SearchableSelect } from 'components/Select/SearchableSelect';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants';

type DisplayedType = ListingType | StaffTypeFilter;

type Props = {
  value: string;
  onChange: (arg0: ListingType) => void;
  listingTypes: Array<DisplayedType>;
};

export function ListingTypeSelect({
  value,
  onChange,
  listingTypes,
  ...props
}: Props) {
  const options = listingTypes.map((type) => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[type],
  }));
  const selectValue = options.map(({ value: v }) => v).find((v) => v === value);
  return (
    <SearchableSelect
      data-qa-id="listing-type-select"
      aria-label={getText('Select listing type')}
      name="listing-types"
      options={options}
      onChange={onChange}
      value={selectValue}
      isClearable={false}
      disabled={listingTypes.length === 1}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
